import type { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types'
import type { PageMeta, PageMeta_Plain } from '@webamboos/admin'

export function usePageMeta() {
  const { localeProperties } = useI18n()
  const { find } = useStrapi()

  const fetchByPath = async (path: string) => {
    const { data } = await find('page-metas', {
      locale: localeProperties.value.code as StrapiLocale,
      populate: ['image'],
      filters: {
        path,
      },
    })
    const meta = data as unknown as PageMeta_Plain[]
    if (!meta[0]) return null
    return meta[0]
  }

  return {
    fetchByPath,
  }
}
